import { http } from 'interfaces'

interface CommentUpdatePayload {
  comment: string
}

export interface KwComment {
  text: string
  last_updated: string
  updated_by: string
}

export const commentService = {
  async updateComment (type: string, id: number, payload: CommentUpdatePayload): Promise<void> {
    await http.put(`/api/v1/us/comment/?type=${type}&id=${id}`, payload)
  },

  async getComment (type: string, id: number): Promise<KwComment> {
    const response = await http.get(`/api/v1/us/comment/?type=${type}&id=${id}`)
    return {
      ...response.data,
      text: response.data.comment
    }
  }
}
